
import React, { useState, useEffect } from 'react';
import { Checkbox, Col, Row } from 'antd';
import './index.css';
import InputDescription from '../quiz-input-show-description/quiz-input-show-description';
import { CheckOutlined } from '@ant-design/icons';
import { useQuizFormContext } from '../../hooks/quiz-form-context';

const CheckboxInput = ({
  title,
  name,
  values = [],
  Error,
  questionValueOptions = [],
  description,
  indexKey,
  allInputOnchageHandler,
  questionTooltip,
}) => {
  const [checkValues, setCheckValues] = useState([]);
  const {
    formValues,
    setContentFulErrorMsg,
    getInputValues,
    allFormErrorsList,
  } = useQuizFormContext();

  // TO RENDER DESCRIPTION OF INPUTS
  function ShowDescription(description) {
    return <InputDescription description={description} questionTooltip={questionTooltip} />;
  }

  function handleInputChange(e, fieldItem) {
    const { name, value } = e.target;
    let checkVal
    if (fieldItem) {
      if (checkValues.some((val) => val?.value == value)) {
        const checkVals = checkValues.filter((item) => item?.value !== value);
        checkVal = checkVals
        setCheckValues(checkVals);
      } else {
        setCheckValues((prev) => [...prev, { id: fieldItem?.sys?.id, value: value }]);
        checkVal = [...checkValues, { id: fieldItem?.sys?.id, value: value }]
      }
    } else {
      setCheckValues((prev) => [...prev, { id: '', value: value }]);
      checkVal = [...checkValues, { id: '', value: value }]
    }
    allInputOnchageHandler(indexKey, title, name, checkVal);
  }


  useEffect(() => {
    if (checkValues?.length > 0) {
      allInputOnchageHandler(indexKey, title, name, checkValues);
    }
  }, [checkValues]);

  useEffect(() => {
    let tempObjVal = getInputValues(name, formValues);
    if (tempObjVal?.value) {
      setCheckValues(tempObjVal?.value);
    }

  }, []);

  //Storing error msg value in state
  useEffect(() => {
    if (Error) {
      setContentFulErrorMsg((prev) => ({ ...prev, [name]: Error }))
    }
  }, [Error])


  return (
    <>
      <Row className="checkbox-main-container">
        <Col span={24}>
          {title && (
            <span className="checkbox-label">
              {Error && <span className="required-field">*</span>}
              {description && ShowDescription(description)}
            </span>
          )}
        </Col>
        <div
          className={
            name === '8' // BusinessSector
              ? `checkbox-item-container horizontal`
              : 'checkbox-item-container'
          }
        >
          {questionValueOptions.map((fieldItem, index) => (
            <label
              className={
                checkValues.some((val) => val?.value == fieldItem?.fields?.value)
                  ? 'checkbox-input-container checkbox-selected'
                  : 'checkbox-input-container'
              }
              key={`${fieldItem.sys.id}`}
            >
              <input
                type="checkbox"
                onChange={(e) => handleInputChange(e, fieldItem)}
                className="checbox-input"
                name={name}
                value={fieldItem?.fields?.value}
              />
              <span className="checkbox-lable">{fieldItem?.fields?.name}</span>
              {checkValues.some((val) => val?.value == fieldItem?.fields?.value) && (
                <CheckOutlined className="check-icon" />
              )}
            </label>
          ))}
        </div>
        {allFormErrorsList[name] && <span className="error-message">{Error?.error || Error}</span>}
      </Row>
    </>
  );
};

export default CheckboxInput;
